import { getFirstNameFromUser as getPreferredGreetingName } from "../../../context/HelperFunctions/getPreferredGreetingName";

export const resolveFirstNameFromUser = async (user = {}) => {
  return getPreferredGreetingName(user);
};

export const formatLondonDateTimeFromTimestamp = (
  timestamp,
  locale = "en-GB",
) => {
  return new Intl.DateTimeFormat(locale, {
    timeZone: "Europe/London",
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  })
    .format(new Date(timestamp))
    .replace(" at ", " • ");
};

export const getLondonHourFromTimestamp = (timestamp) => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/London",
    hour: "numeric",
    hour12: false,
  }).formatToParts(new Date(timestamp));

  return Number(parts.find((part) => part.type === "hour")?.value || 0);
};

export const getGreetingFromTimestamp = (timestamp, name = "") => {
  const hour = getLondonHourFromTimestamp(timestamp);

  if (hour < 12) return `Good morning${name ? `, ${name}!` : ""}`;
  if (hour < 18) return `Good afternoon${name ? `, ${name}!` : ""}`;
  return `Good evening${name ? `, ${name}!` : ""}`;
};

export const getPortalGreetingDataFromTimestamp = (
  timestamp,
  firstName = "",
  locale = "en-GB",
) => {
  const greeting = getGreetingFromTimestamp(timestamp, firstName);
  const formattedDateTime = formatLondonDateTimeFromTimestamp(
    timestamp,
    locale,
  );

  return {
    firstName,
    greeting,
    formattedDateTime,
  };
};
